import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx"
import * as query from "query-string"
import ElementModel from "../../model/ElementModel";

export class ComTopSearchStore {

    search: string = '';
    rows = [];
    isFocus = false;
    categories = [];
    statusSearch: boolean = false;
    private inputTimer: NodeJS.Timeout | undefined;

    private rootStore: RootStore | undefined;

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init() {
        let urlOb = query.parse(window.location.search);
        if (urlOb.q !== undefined) {
            this.search = String(urlOb.q);
        }
        this.reload(true);
    }
    initByCategory() {
        let urlOb = query.parse(window.location.search);
        if (urlOb.q !== undefined) {
            this.search = String(urlOb.q);
        }
        this.reloadByCategory(true);
    }

    onChangeInput = (e: any) => {
        this.statusSearch = true
        this.search = e.target.value;
        if (this.inputTimer) {
            clearTimeout(this.inputTimer);
        }
        this.inputTimer = setTimeout(() => {
            this.reload();
        }, 1000);
    }

    onBlurInput = (e: any) => {

        setTimeout(() => {
            this.isFocus = false;
            this.search = '';
            this.rows = [];
            this.categories = [];
        }, 1000)
    }

    onFocus = () => {
        this.isFocus = true;
    }


    reload(isCount = false) {
        
        // if(clientId === 0){
        //     // this.rootStore?.authStore.removeData()
        //     // this.rootStore?.authStore.init()
        //     this.rootStore?.mainStore.init()
        // }
        this.statusSearch = true
        let clientId = this.rootStore?.mainStore.getClientId() ?? 0;
      
        if(isCount){
            ElementModel.searchLimit(this.search, clientId, this.setData, this.setError)
        }else{
            ElementModel.search(this.search, clientId, this.setData, this.setError)
        }
    }
    reloadByCategory(isCount = false) {
        let clientId = this.rootStore?.mainStore.getClientId();
        ElementModel.searchByCategory(this.search, clientId, this.setData, this.setError)
        this.search = '';
        // if(isCount){
        //     ElementModel.searchLimit(this.search, clientId, this.setData, this.setError)
        // }else{
        //     ElementModel.search(this.search, clientId, this.setData, this.setError)
        // }
    }

    @action
    setData = (result: any) => {
        if (result.data.rows) {
            this.rows = result.data.rows;
        } else {
            this.rows = [];
        }

        if(result.data.categories){
            this.categories = result.data.categories;
            console.log(this.categories)
        }else{
            this.categories = []
        }
        this.statusSearch = false

    }

    @action
    clearSearch = () => {
        if ('/catalog/search' !== window.location.pathname) {
            this.search = ''
        }
    }

    @action
    setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }
}